/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface PaymentExpirationConfigLogDetail {
  dateCreated?: Date;
  logId?: number;
  newDescription?: string;
  newExpirationTime?: number;
  newName?: string;
  oldDescription?: string;
  oldExpirationTime?: number;
  oldName?: string;
  paymentExpirationConfigId?: number;
  userId?: number;
  username?: string;
}
